<template>
    <el-popover trigger="hover" class="pointer" popper-class="p-1">
        <template slot="reference">
            <span :class="inverted ? 'text-white' : 'text-theme-heading'" class="d-flex gap-2" @click.stop="downloadIcsFile">
                <font-awesome-icon icon="calendar-plus"/>
                <small v-if="!noLabel">{{ $t('iFrame.addToCalendar') }}</small>
            </span>
        </template>
        <template>
            <div class="dropdown-item pointer text-theme-primary" @click="downloadIcsFile">
                <font-awesome-icon class="mr-1" icon="download" size="sm"/>
                {{ $t('iFrame.downloadIcal') }}
            </div>
            <div class="dropdown-item pointer text-theme-primary" @click="linkToGoogleCalendar">
                <font-awesome-icon class="mr-1" icon="calendar-day" size="sm"/>
                {{ $t('iFrame.openGoogleCalendar') }}
            </div>
            <div class="dropdown-item pointer text-theme-primary" @click="linkToOutlookCalendar">
                <font-awesome-icon class="mr-1" icon="calendar-day" size="sm"/>
                {{ $t('iFrame.openOutlookCom') }}
            </div>
        </template>
    </el-popover>
</template>

<script>
export default {
    name: "EventEntryIcalElement",
    props: {
        event: {
            required: true
        },
        noLabel: {
            type: Boolean
        },
        inverted: {
            type: Boolean
        }
    },
    computed: {
        addToGoogleCalendarLink() {
            return "http://www.google.com/calendar/render?action=TEMPLATE" +
                "&text=" + this.event.icalContent.summary +
                "&dates=" + this.event.icalContent.start_google + (this.event.icalContent.end_google ? "/" + this.event.icalContent.end_google : "") +
                "&details=" + this.event.icalContent.description +
                (this.event.icalContent.location ? "&location=" + this.event.icalContent.location : "")
        },
        addToOfficeCalendarLink() {
            return "https://outlook.office.com/calendar/0/deeplink/compose?" +
                "body=" + this.event.icalContent.description +
                (this.event.icalContent.end_outlook ? "&enddt=" + this.event.icalContent.end_outlook : "") +
                (this.event.icalContent.location ? "&location=" + this.event.icalContent.location : "") +
                "&path=%2Fcalendar%2Faction%2Fcompose" +
                "&rru=addevent" +
                "&startdt=" + this.event.icalContent.start_outlook +
                "&subject=" + this.event.icalContent.summary
        }
    },
    methods: {
        downloadIcsFile() {
            let element = document.createElement('a');
            let fileName = "invite.ics";
            element.setAttribute('href', 'data:calendar/ics;charset=utf-8,' + encodeURIComponent(this.event.icalContent.icsAsString));
            element.setAttribute('download', fileName);
            element.style.display = 'none';
            document.body.appendChild(element);
            element.click();
            document.body.removeChild(element);
        },
        linkToGoogleCalendar() {
            window.open(this.addToGoogleCalendarLink, '_blank').focus()
        },
        linkToOutlookCalendar() {
            window.open(this.addToOfficeCalendarLink, '_blank').focus()
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep .el-popover {
    padding: 0 !important;
}
</style>
